export enum TariffInfo {
  maxUsers = 20,
  maxMonth = 12,
  contactCreditsPerUser = 5,
  exportCreditsPerUser = 20,
  customMonthException = 1
}
